import React from 'react';
import './FAQService.css';
import FAQServiceItem from './FAQServiceItem';

function FAQService() {
  const faqs = [
    {
      id: 1,
      question: "How can I check my vehicle's challan status?",
      answer: "You can check your vehicle's challan status by entering your vehicle registration number in the search box at the top of the home page. Our system will retrieve all the relevant information related to your vehicle."
    },
    {
      id: 2,
      question: "What documents are required for vehicle ownership transfer?",
      answer: "For vehicle ownership transfer, you'll need the original RC, valid insurance, PUC certificate, NOC from RTO (if applicable), address proof, ID proof, and transfer fee payment receipt. Additional documents may be required based on your state's RTO regulations."
    },
    {
      id: 3,
      question: "How can I get my vehicle insurance renewed?",
      answer: "You can renew your vehicle insurance through our platform by navigating to the Insurance section. Simply enter your vehicle details, select the preferred insurance plan, complete the payment, and receive your policy documents instantly."
    },
    {
      id: 4,
      question: "Can I sell my vehicle through this platform?",
      answer: "Yes, you can list your vehicle for sale on our platform. Navigate to the 'Sell Your Car' or 'Sell Your Bike' section, upload vehicle details and photos, set your asking price, and connect with potential buyers."
    },
    {
      id: 5,
      question: "How do I apply for a driving license test?",
      answer: "To apply for a driving license test, go to the 'DL Test' section, fill in your personal details, select your preferred RTO center and time slot, upload the required documents, and complete the fee payment. You'll receive a confirmation with test date and location."
    },
    {
      id: 6,
      question: "What types of loans are available on this platform?",
      answer: "We offer various types of loans including Vehicle Loans, Instant Loans, Personal Loans, and Refinance Loans. Each loan type has different eligibility criteria, interest rates, and repayment terms tailored to your needs."
    }
  ];

  return (
    <div className="faq-section">
      <h2 className="faq-header">Frequently Asked Questions</h2>
      <div className="faq-container">
        {faqs.map((faq) => (
          <FAQServiceItem 
            key={faq.id} 
            question={faq.question} 
            answer={faq.answer}
            isOpen={faq.id === 1} // First item will be open by default
          />
        ))}
      </div>
    </div>
  );
}

export default FAQService;